export const CUSTOM_ICONS = [
  'stripe'
];
